var map = {
	"./downloads/batteries_b-roll.mp4": 4811,
	"./downloads/bedroom_b-roll.mp4": 494,
	"./downloads/testing_b-roll.mp4": 2146,
	"./landingpage/1.FIRESAFETY_CANDLES.mp4": 4786,
	"./landingpage/2.FIRESAFETY_Cooking.mp4": 381,
	"./landingpage/3.FIRESAFETY_PHONE_.mp4": 171,
	"./landingpage/4.FIRESAFETY_SOCKET.mp4": 920,
	"./landingpage/5.FIRESAFETY_TONGS.mp4": 7377,
	"./landingpage/6.FireSafety-Christmas lights.mp4": 1468,
	"./landingpage/Czech.mp4": 3849,
	"./landingpage/Denmark.mp4": 9546,
	"./landingpage/Estonia.mp4": 4677,
	"./landingpage/Finian.mp4": 1443,
	"./landingpage/Finland.mp4": 2504,
	"./landingpage/Ireland.mp4": 9541,
	"./landingpage/Latvia.mp4": 1183,
	"./landingpage/Lithuania1.mp4": 1784,
	"./landingpage/Lithuania2.mp4": 991,
	"./landingpage/Maria.mp4": 2354,
	"./landingpage/Spain.mp4": 3623,
	"./landingpage/Stephan.mp4": 791,
	"./landingpage/Sweden.mp4": 7574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6197;